/* Setting the Standard — theme.js */

/* Hero background video: use each block's "Start time" setting, loop back to that same point (not zero) */
(function(){
  var cols = document.querySelectorAll('.stack-vid-col[data-start]');
  if(cols.length > 0){
    cols.forEach(function(col){
      var start = parseFloat(col.dataset.start) || 0;
      var vid = col.querySelector('.stack-vid');
      if(!vid) return;
      var seekToStart = function(){
        try{ vid.currentTime = start; }catch(e){}
      };
      vid.addEventListener('loadedmetadata', seekToStart);
      if(vid.readyState >= 1) seekToStart();
      vid.addEventListener('ended', function(){
        seekToStart();
        vid.play();
      });
    });
  } else {
    /* Fallback (no video blocks configured): old fixed offsets for the default triptych */
    var offsets=[0,4,2];
    document.querySelectorAll('.stack-vid').forEach(function(vid,i){
      vid.addEventListener('loadedmetadata',function(){if(vid.duration) vid.currentTime=(offsets[i]%vid.duration);});
    });
  }
  setTimeout(function(){var s=document.getElementById('heroBgStack');if(s) s.style.animation='slowZoomOut 12s ease-in-out forwards';},8000);
})();

/* Nav background fade-in on scroll */
window.addEventListener('scroll',function(){var n=document.getElementById('mainNav');if(n) n.classList.toggle('scrolled',window.scrollY>60);});

/* Fade/slide reveal animation for .reveal elements as they enter the viewport */
window.STS = window.STS || {};
STS.initReveals = function(root){
  var scope = root || document;
  var reveals = scope.querySelectorAll('.reveal:not(.visible)');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e, i){
      if(e.isIntersecting){
        setTimeout(function(){ e.target.classList.add('visible'); }, i * 80);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  reveals.forEach(function(el){ io.observe(el); });
};
STS.initReveals();

/* Animated letter-by-letter hero headline (first letter of each word enlarged) */
(function(){
  var heroTitleEl=document.getElementById('heroTitle');
  if(!heroTitleEl) return;
  var line1=heroTitleEl.getAttribute('data-line1')||'Setting';
  var line2=heroTitleEl.getAttribute('data-line2')||'the Standard';
  var lines=[{id:'titleLine1',text:line1,baseDelay:400},{id:'titleLine2',text:line2,baseDelay:900}];
  lines.forEach(function(line){
    var el=document.getElementById(line.id);if(!el) return;
    var html='';var li=0;
    for(var i=0;i<line.text.length;i++){var ch=line.text[i];
      if(ch===' '){html+='<span style="display:inline-block;width:0.28em;"></span>';}
      else{var delay=line.baseDelay+li*90;var isFirst=(i===0||line.text[i-1]===' ');var fsz=isFirst?'font-size:1.35em;':'';html+='<span class="hero-letter" style="animation-delay:'+delay+'ms;'+fsz+'">'+ch+'</span>';li++;}
    }
    el.innerHTML=html;
  });
})();

/* Horse runs along the top edge of the header, position tied to scroll percentage.
   Swaps to walking gif while actively scrolling, settles to a still frame when scrolling stops. */
(function(){
  var img=document.getElementById('scroll-horse-img');
  var wrap=document.getElementById('scroll-horse');
  var nav=document.getElementById('mainNav');
  if(!img || !wrap || !nav) return;
  var gifSrc=img.getAttribute('data-gif');var stillSrc=img.getAttribute('data-still');
  var scrollTimer=null;var isAnimating=false;
  var navToggle = document.getElementById('navToggle');

  var lastScrollY = window.scrollY;

  function updatePosition(){
    var rightBoundary = nav.offsetWidth;
    if(navToggle && getComputedStyle(navToggle).display !== 'none'){
      rightBoundary = navToggle.offsetLeft - 12; /* stop before the hamburger icon on mobile */
    }
    var trackWidth = rightBoundary - wrap.offsetWidth;
    if(trackWidth <= 0) return;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var pct = docHeight > 0 ? (window.scrollY / docHeight) : 0;
    var x = Math.min(Math.max(pct, 0), 1) * trackWidth;
    wrap.style.transform = 'translateX(' + x + 'px)';

    var currentScrollY = window.scrollY;
    if(currentScrollY > lastScrollY + 1){
      img.style.transform = 'scaleX(1)';   /* scrolling down -> moving right -> face right */
    } else if(currentScrollY < lastScrollY - 1){
      img.style.transform = 'scaleX(-1)';  /* scrolling up -> moving left -> face left */
    }
    lastScrollY = currentScrollY;
  }

  window.addEventListener('scroll', function(){
    if(!isAnimating){img.src=gifSrc;isAnimating=true;}
    clearTimeout(scrollTimer);
    scrollTimer=setTimeout(function(){img.src=stillSrc;isAnimating=false;},150);
    updatePosition();
  }, { passive: true });

  window.addEventListener('resize', updatePosition);
  updatePosition();
})();

/* Header top strip video: aggressively ensure it actually plays (autoplay attribute
   alone is unreliable across browsers, especially when muted isn't set as a JS property) */
(function(){
  var vid = document.getElementById('header-top-strip-video');
  if(!vid) return;

  vid.muted = true;
  vid.defaultMuted = true;
  vid.setAttribute('muted', '');
  vid.setAttribute('playsinline', '');
  vid.setAttribute('webkit-playsinline', '');

  var attempts = 0;
  function tryPlay(){
    attempts++;
    var p = vid.play();
    if(p && p.catch){
      p.catch(function(){
        if(attempts < 5) setTimeout(tryPlay, 400);
      });
    }
  }

  vid.addEventListener('loadedmetadata', tryPlay);
  vid.addEventListener('loadeddata', tryPlay);
  vid.addEventListener('canplay', tryPlay);
  document.addEventListener('click', tryPlay, { once: true });
  document.addEventListener('touchstart', tryPlay, { once: true });

  tryPlay();
  setTimeout(tryPlay, 300);
  setTimeout(tryPlay, 1000);
})();

/* ---------- CART DRAWER + STORY MODAL + SIZE GUIDE MODAL ---------- */
(function(){
  var backdrop = document.getElementById('modalBackdrop');
  var cartDrawer = document.getElementById('cartDrawer');
  var storyModal = document.getElementById('storyModal');
  var sizeGuideModal = document.getElementById('sizeGuideModal');
  if(!backdrop || !cartDrawer || !storyModal) return;

  function closeAll(){
    cartDrawer.classList.remove('open');
    storyModal.classList.remove('open');
    if(sizeGuideModal) sizeGuideModal.classList.remove('open');
    backdrop.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.STS = window.STS || {};
  STS.closeModals = closeAll;

  function openCartDrawer(){
    closeAll();
    cartDrawer.classList.add('open');
    backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function openStoryModal(){
    closeAll();
    storyModal.classList.add('open');
    backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function openSizeGuideModal(){
    if(!sizeGuideModal) return;
    closeAll();
    sizeGuideModal.classList.add('open');
    backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener('click', function(e){
    var cartTrigger = e.target.closest('.js-cart-trigger');
    var storyTrigger = e.target.closest('.js-story-trigger');
    var sizeGuideTrigger = e.target.closest('.js-size-guide-trigger');
    if(cartTrigger){
      e.preventDefault();
      openCartDrawer();
      return;
    }
    if(storyTrigger){
      e.preventDefault();
      openStoryModal();
      return;
    }
    if(sizeGuideTrigger){
      e.preventDefault();
      openSizeGuideModal();
      return;
    }
  });

  var cartDrawerClose = document.getElementById('cartDrawerClose');
  var storyModalClose = document.getElementById('storyModalClose');
  var sizeGuideModalClose = document.getElementById('sizeGuideModalClose');
  if(cartDrawerClose) cartDrawerClose.addEventListener('click', closeAll);
  if(storyModalClose) storyModalClose.addEventListener('click', closeAll);
  if(sizeGuideModalClose) sizeGuideModalClose.addEventListener('click', closeAll);
  backdrop.addEventListener('click', closeAll);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeAll();
  });

  function renderCartSkeleton(){
    var currentBody = document.getElementById('cartDrawerBody');
    if(!currentBody) return;
    var rows = '';
    for(var i = 0; i < 3; i++){
      rows += '<div class="cart-skeleton-row">' +
        '<div class="cart-skeleton-img shimmer"></div>' +
        '<div class="cart-skeleton-lines">' +
          '<div class="cart-skeleton-line shimmer" style="width:70%;"></div>' +
          '<div class="cart-skeleton-line shimmer" style="width:40%;"></div>' +
          '<div class="cart-skeleton-line shimmer" style="width:55%;"></div>' +
        '</div>' +
      '</div>';
    }
    currentBody.innerHTML = '<div class="cart-skeleton">' + rows + '</div>';
  }

  function refreshCartDrawer(){
    renderCartSkeleton();
    if(STS.renderCartPreview) STS.renderCartPreview();
    fetch(window.location.pathname + '?sections=header-group__header')
      .then(function(res){ return res.json(); })
      .then(function(data){
        var html = data['header-group__header'];
        if(!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshBody = doc.getElementById('cartDrawerBody');
        var currentBody = document.getElementById('cartDrawerBody');
        if(freshBody && currentBody) currentBody.innerHTML = freshBody.innerHTML;
        fetch('/cart.js')
          .then(function(r){ return r.json(); })
          .then(function(cart){
            document.querySelectorAll('#mainNav .nav-links a[href*="/cart"]').forEach(function(a){
              a.textContent = 'Cart (' + cart.item_count + ')';
            });
          })
          .catch(function(){});
      })
      .catch(function(){});
  }

  var cartDrawerBody = document.getElementById('cartDrawerBody');
  if(cartDrawerBody){
    cartDrawerBody.addEventListener('click', function(e){
      var btn = e.target.closest('[data-line]');
      if(!btn) return;
      var line = btn.dataset.line;
      var updates = {};

      if(btn.classList.contains('cart-drawer-remove')){
        updates.line = line; updates.quantity = 0;
      } else if(btn.dataset.action === 'increase' || btn.dataset.action === 'decrease'){
        var valueEl = btn.parentElement.querySelector('.cart-drawer-qty-value');
        var current = parseInt(valueEl.textContent, 10) || 1;
        var next = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
        updates.line = line; updates.quantity = next;
      } else {
        return;
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      })
        .then(function(res){ return res.json(); })
        .then(function(){ refreshCartDrawer(); })
        .catch(function(){});
    });
  }
})();

/* ---------- MOBILE NAV TOGGLE ---------- */
(function(){
  var toggle = document.getElementById('navToggle');
  var links = document.getElementById('navLinks');
  if(!toggle || !links) return;
  toggle.addEventListener('click', function(){
    var open = links.classList.toggle('open');
    toggle.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  links.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', function(){
      links.classList.remove('open');
      toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  });
})();

/* ---------- PRODUCT IMAGE ZOOM (magnifying glass) ---------- */
STS.initZoom = function(){
  var wrap = document.getElementById('pdpZoomWrap');
  var img = document.getElementById('pdp-main-img');
  var lens = document.getElementById('pdpZoomLens');
  if(!wrap || !img || !lens) return;
  if(wrap.dataset.zoomBound === 'true') return;
  wrap.dataset.zoomBound = 'true';
  if(window.matchMedia('(pointer: coarse)').matches) return;

  var lensSize = 180;
  var zoomFactor = 2.2;

  function updateLens(e){
    var rect = wrap.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    if(x < 0 || y < 0 || x > rect.width || y > rect.height){
      wrap.classList.remove('zooming');
      return;
    }
    wrap.classList.add('zooming');
    lens.style.left = x + 'px';
    lens.style.top = y + 'px';

    var zoomSrc = img.dataset.zoom || img.src;
    lens.style.backgroundImage = 'url(' + zoomSrc + ')';
    var bgWidth = rect.width * zoomFactor;
    var bgHeight = rect.height * zoomFactor;
    lens.style.backgroundSize = bgWidth + 'px ' + bgHeight + 'px';
    var bgX = (x / rect.width) * bgWidth - lensSize / 2;
    var bgY = (y / rect.height) * bgHeight - lensSize / 2;
    lens.style.backgroundPosition = (-bgX) + 'px ' + (-bgY) + 'px';
  }

  wrap.addEventListener('mousemove', updateLens);
  wrap.addEventListener('mouseleave', function(){
    wrap.classList.remove('zooming');
  });
};
STS.initZoom();

/* ---------- RECENTLY VIEWED PRODUCTS ---------- */
STS.initRecentlyViewed = function(){
  var dataEl = document.getElementById('currentProductData');
  var container = document.getElementById('recentlyViewed');
  var track = document.getElementById('recentlyViewedTrack');
  if(!container || !track) return;
  if(container.dataset.rvBound === 'true') return;
  container.dataset.rvBound = 'true';

  var STORAGE_KEY = 'sts_recently_viewed';
  var MAX_ITEMS = 8;

  function getStored(){
    try{
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    }catch(e){ return []; }
  }

  function setStored(list){
    try{ localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }catch(e){}
  }

  if(dataEl){
    try{
      var current = JSON.parse(dataEl.textContent);
      var list = getStored().filter(function(p){ return p.handle !== current.handle; });
      list.unshift(current);
      if(list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
      setStored(list);
    }catch(e){}
  }

  var currentHandle = dataEl ? JSON.parse(dataEl.textContent).handle : null;
  var toShow = getStored().filter(function(p){ return p.handle !== currentHandle; }).slice(0, 6);

  if(toShow.length === 0) return;

  track.innerHTML = '';
  toShow.forEach(function(p){
    var a = document.createElement('a');
    a.className = 'rv-card';
    a.href = p.url;
    a.innerHTML =
      '<img class="rv-card-img" src="' + p.image + '" alt="" loading="lazy">' +
      '<p class="rv-card-title">' + p.title + '</p>' +
      '<p class="rv-card-price">' + p.price + '</p>';
    track.appendChild(a);
  });

  container.style.display = 'block';
};
STS.initRecentlyViewed();

/* ---------- SMOOTH PAGE TRANSITIONS (no hard reloads) ---------- */
(function(){
  var main = document.getElementById('page-content');
  if(!main) return;
  if(!window.history || !window.history.pushState) return;

  function isTransitionable(link){
    if(!link) return false;
    if(link.target && link.target !== '' && link.target !== '_self') return false;
    if(link.hasAttribute('download')) return false;
    if(link.dataset.popup) return false; /* cart/story/size-guide triggers handle their own thing */
    var href = link.getAttribute('href');
    if(!href || href.charAt(0) === '#') return false;
    if(href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return false;
    if(link.origin !== window.location.origin) return false;
    if(/\/(cart|checkout|account)(\/|$)/.test(link.pathname)) return false;
    if(link.pathname === window.location.pathname && link.hash) return false;
    return true;
  }

  function runInjectedScripts(container){
    var scripts = container.querySelectorAll('script');
    scripts.forEach(function(old){
      var fresh = document.createElement('script');
      for(var i = 0; i < old.attributes.length; i++){
        fresh.setAttribute(old.attributes[i].name, old.attributes[i].value);
      }
      fresh.textContent = old.textContent;
      old.parentNode.replaceChild(fresh, old);
    });
  }

  function initSwappedContent(){
    STS.initReveals(main);
    STS.initZoom();
    STS.initRecentlyViewed();
    if(STS.renderCartPreview) STS.renderCartPreview();
    runInjectedScripts(main);
  }

  function navigate(url, addToHistory){
    if(STS.closeModals) STS.closeModals();
    main.classList.add('page-transitioning');
    fetch(url)
      .then(function(res){ return res.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshMain = doc.getElementById('page-content');
        if(!freshMain){ window.location.href = url; return; }

        setTimeout(function(){
          main.innerHTML = freshMain.innerHTML;
          document.title = doc.title;
          if(addToHistory) window.history.pushState({}, '', url);
          window.scrollTo({ top: 0, behavior: 'auto' });
          main.classList.remove('page-transitioning');
          initSwappedContent();
        }, 220);
      })
      .catch(function(){
        window.location.href = url;
      });
  }

  document.addEventListener('click', function(e){
    var link = e.target.closest('a');
    if(!isTransitionable(link)) return;
    e.preventDefault();
    navigate(link.href, true);
  });

  window.addEventListener('popstate', function(){
    navigate(window.location.href, false);
  });
})();

/* ---------- CART PREVIEW BANNER (shows above shop categories) ---------- */
window.STS = window.STS || {};
STS.renderCartPreview = function(){
  var banner = document.getElementById('cartPreviewBanner');
  var track = document.getElementById('cartPreviewTrack');
  if(!banner || !track) return;

  fetch('/cart.js')
    .then(function(res){ return res.json(); })
    .then(function(cart){
      if(!cart.items || cart.items.length === 0){
        banner.style.display = 'none';
        return;
      }
      track.innerHTML = '';
      cart.items.slice(0, 10).forEach(function(item){
        var div = document.createElement('div');
        div.className = 'cart-preview-item';
        var imgSrc = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_100x100$1$2') : '';
        div.innerHTML =
          '<img src="' + imgSrc + '" alt="" loading="lazy">' +
          (item.quantity > 1 ? '<span class="cart-preview-qty">' + item.quantity + '</span>' : '');
        track.appendChild(div);
      });
      banner.style.display = 'flex';
    })
    .catch(function(){});
};
STS.renderCartPreview();
document.addEventListener('submit', function(e) {
  // Check if the submitted form is an Add to Cart form
  if (e.target.matches('form[action="/cart/add"], form[action^="/cart/add"]')) {
    e.preventDefault(); // Stop the form from redirecting the browser

    const form = e.target;
    const submitButton = form.querySelector('[type="submit"]');
    const originalText = submitButton ? submitButton.innerText : 'Add to Cart';

    // Optional: Visual feedback that the item is adding
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.innerText = 'Adding...';
    }

    // Send the data to Shopify in the background
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
    .then(response => response.json())
    .then(data => {
      // Success feedback
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerText = 'Added!';
        
        // Reset the button text back to normal after 2 seconds
        setTimeout(() => {
          submitButton.innerText = originalText;
        }, 2000);
      }
      
      console.log('Item successfully added to cart:', data);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerText = originalText;
      }
    });
  }
});
